<template>
<v-container>
  <v-layout v-if="imageUrl">
    <div v-if="isErrorModalLargeImageVisible">
      <div>
        Too large image
      </div>
      <div>
        Your image is {{imageSize}}mb. It has to be {{maxImageSize}}mb maximum.
      </div>
    </div>
  </v-layout>
  <v-layout row>
    <v-flex
      class="crop-wrapper"
      v-if="imageUrl"
      xs5
    > <p class="cropper-message">You can crop and rotate image: </p>
      <vue-cropper
        ref="cropper"
        :src="imageUrl"
        alt="Source Image"
        :guides="true"
        :cropmove="cropImage"
        :min-container-height="300"
        :key="imageUrl"
        :autoCrop="true"
      >
      </vue-cropper>
    </v-flex>
    <v-flex
      v-if="imageUrl"
      class="cropper-block"
      xs5 offset-xs1 >
      <p class="cropper-message">Image to save: </p>
      <img alt="Preview image. Choose image area to see the preview" :style="previewStyle" max-height="300" id='output' :src="newUrl" :key="newUrl">
    </v-flex>
  </v-layout>
  <v-layout>
    <v-flex xs12 sm6 class="cropper-block text-xs-left py-2">
      <input
        id="fileLoader"
        ref="input"
        type="file"
        accept="image/*"
        class="ch-file-btn__input"
        @change="uploadFile"
      />
      <v-btn
        v-if="imageUrl"
        class="cropper-button"
        @click.native="rotateLeft()">
        Rotate
      </v-btn>
    </v-flex>
  </v-layout>
</v-container>
</template>
<script>
import { clone } from 'ramda'

export default {
  name: 'image-cropper',
  props: {
    setImgUrl: {
      type: [String]
    }
  },
  data () {
    return {
      file: null,
      imageToSaveUrl: '',
      imageUrl: '',
      newUrl: '',
      croppedSrc: '',
      isErrorModalLargeImageVisible: false,
      imageSize: 0,
      maxImageSize: 3,
      previewStyle: {
        maxHeight: '230px'
      }
    }
  },
  watch: {
    setImgUrl: {
      handler() {
        this.imageUrl = this.setImgUrl
        const result = {
          type: 'image/jpeg'
        }
        this.file = clone(result)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    cropImage (e) {
      const canvas = this.$refs.cropper.getCroppedCanvas()
      const newUrl = canvas.toDataURL(this.file.type)
      this.newUrl = newUrl
      canvas.toBlob(data => {
        this.imageToSaveUrl = newUrl
        this.$emit('saveEditedImage', newUrl)
      })
    },
    rotateLeft () {
      this.$refs.cropper.rotate(90)
      this.cropImage()
    },
    uploadFile (e) {
      const file = (e.target.files || e.dataTransfer.files)[0]
      this.imageSize = Math.round((file.size / 1024000))
      if (this.imageSize > this.maxImageSize) {
        this.isErrorModalLargeImageVisible = true
        return
      }
      const reader = new FileReader()
      reader.onload = () => {
        let dataURL = reader.result
        this.imageUrl = dataURL
        const result = {
                name: file.name,
                size: file.size,
                url: reader.result,
                type: file.type,
                file
              }
              this.file = clone(result)
      }
      reader.readAsDataURL(file)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/AImageCropper/index.vue